type LocaleConfig = {
  locale: string;
  currency: string;
};

export type SupportedLanguages = 'en' | 'es' | 'pt';

const localeCurrencyMap: Record<SupportedLanguages, LocaleConfig> = {
  en: { locale: 'en-US', currency: 'USD' },
  es: { locale: 'es-AR', currency: 'ARS' },
  pt: { locale: 'pt-BR', currency: 'BRL' },
};

export const valueToCurrencyFormat = (value: number | string, lang: string): string => {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  const { locale, currency } = localeCurrencyMap[lang as SupportedLanguages] ?? localeCurrencyMap['es'];

  const newValue = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(numberValue);

  return newValue;
};
